import React from 'react';

export const ProSpinner = () => (
    <div className="ProSpinner">
        {/* <Spinner intent="primary" /> */}
        <div className="loader">Loading...</div>
    </div>
);
